<template>
    <on-click-outside :do="close">
        <div class="relative" :class="{'is-active': showComponent}">
            <div ref="button" class="p-1 cursor-pointer" @click.stop.prevent="switchPopper">
                <div class="border-2 rounded-full w-8 h-8 ml-3 flex flex-row items-center justify-center">
                    <img class="" src="@/assets/SVG/fill_1.svg"/>
                </div>
            </div>
            <div ref="panel" v-if="showComponent" class="absolute rounded-lg flex flex-col bg-white shadow-md z-50">
                <div>
                    <div @click.stop.prevent="logout" class="flex flex-row hover:bg-red hover:text-white p-2 rounded-lg cursor-pointer">
                        <p>Выйти</p>
                    </div>
                </div>
            </div>
        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../views/OnClickOutside.vue';

export default {
  name: 'logout-modal',
  components: { OnClickOutside },

  data() {
    return {
      showComponent: false,
      showConfirm: false,
    };
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  },
  methods: {
    disInput() {
      this.$emit('disableInput');
      this.close();
    },
    switchPopper() {
      this.showComponent = !this.showComponent;
      this.showConfirm = false;
      if (this.showComponent) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    logout() {
      this.$store.dispatch('logout');
      this.showComponent = !this.showComponent;
      this.$router.push({ name: 'login' });
    },
    setupPopper() {
      this.popper = undefined;
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.panel, {
          placement: 'bottom',
          positionFixed: false,
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    close() {
      if (!this.showComponent) {
        return;
      }
      this.showComponent = false;
    },
  },
};
</script>

<style scoped lang="less">
    .button-class{
        color: white;
        border-radius: 1rem;
    }
</style>
